import { render, staticRenderFns } from "./TagComponent.vue?vue&type=template&id=2b77249b&"
import script from "./TagComponent.vue?vue&type=script&lang=ts&"
export * from "./TagComponent.vue?vue&type=script&lang=ts&"
import style0 from "./TagComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports